import { V } from "@/lib/formErrors";
import { titolo } from "@/lib/formato";

export const FORME = ["srl", "snc", "sas", "spa", "ditta individuale", "altro"];
export const isGiuridica = (c) => c?.tipo_soggetto === "giuridica";
export const nomePersona = (c) => titolo(`${c?.nome || ""} ${c?.cognome || ""}`.trim());
export const nomeCliente = (c) => (isGiuridica(c) && c.societa_ragione_sociale ? c.societa_ragione_sociale : nomePersona(c));

const piva = (v) => (!v || !String(v).trim()) ? null : (/^\d{11}$/.test(String(v).trim()) ? null : "Partita IVA non valida (11 cifre)");
export const regoleGiuridica = {
  societa_ragione_sociale: [V.required], societa_piva: [V.required, piva], societa_cf: [V.cf],
  societa_pec: [V.email], societa_email: [V.email], societa_telefono: [V.phone], nome: [V.required], cognome: [V.required],
};

export function SocietaBadge({ c }) {
  if (!isGiuridica(c)) return null;
  return <span data-testid="badge-societa" className="ml-2 align-middle px-2 py-0.5 rounded-full bg-indigo-50 text-indigo-700 border border-indigo-200 text-[10px] font-bold uppercase">Società</span>;
}

export function NomeCard({ c }) {
  return (
    <>
      <span>{nomeCliente(c)}</span><SocietaBadge c={c} />
      {isGiuridica(c) && nomePersona(c) && <div className="text-xs font-normal text-[var(--muted)]" data-testid="legale-rappresentante">Leg. rapp.: {nomePersona(c)}</div>}
    </>
  );
}

export function TipoSoggetto({ value, onChange, prefix = "ts" }) {
  return (
    <div className="flex gap-4 flex-wrap mb-3 text-sm" data-testid={`${prefix}-tipo-soggetto`}>
      {[["fisica", "Persona fisica"], ["giuridica", "Persona giuridica (società / ditta con P.IVA)"]].map(([k, l]) => (
        <label key={k} className="inline-flex items-center gap-2 cursor-pointer font-semibold">
          <input type="radio" data-testid={`${prefix}-tipo-${k}`} checked={(value || "fisica") === k} onChange={() => onChange(k)} className="accent-[#FC82ED]" /> {l}
        </label>
      ))}
    </div>
  );
}

const inp = "w-full px-3 py-2 rounded-lg bg-white border outline-none text-sm focus:border-[#FC82ED]";
const lab = "block text-[11px] font-semibold uppercase tracking-wide text-[var(--muted)] mb-1";
const CAMPI = [
  ["societa_ragione_sociale", "Ragione sociale *"], ["societa_forma", "Forma giuridica", "forma"], ["societa_piva", "Partita IVA *"],
  ["societa_cf", "Codice fiscale società"], ["societa_comune", "Sede legale: comune"], ["societa_via", "Sede legale: via"],
  ["societa_civico", "Sede legale: civico"], ["societa_cap", "Sede legale: CAP"], ["societa_email", "Email società"],
  ["societa_pec", "PEC società"], ["societa_sdi", "Codice destinatario SDI"], ["societa_telefono", "Telefono società"],
];

export function SocietaFields({ f, set, errors = {}, prefix = "ts" }) {
  return (
    <div className="grid sm:grid-cols-2 gap-3 mb-4" data-testid={`${prefix}-societa-fields`}>
      {CAMPI.map(([k, l, t]) => (
        <div key={k} data-field-error={errors[k] ? "true" : undefined}>
          <label className={lab}>{l}</label>
          {t === "forma" ? (
            <select data-testid={`${prefix}-${k}`} value={f[k] || ""} onChange={(e) => set(k, e.target.value)} className={`${inp} border-[var(--border)]`}>
              <option value="">—</option>{FORME.map((x) => <option key={x} value={x}>{x}</option>)}
            </select>
          ) : (
            <input data-testid={`${prefix}-${k}`} value={f[k] || ""} onChange={(e) => set(k, e.target.value)}
              className={`${inp} ${errors[k] ? "border-red-500 bg-red-50" : "border-[var(--border)]"}`} />
          )}
          {errors[k] && <p className="text-[11px] text-red-600 mt-1" data-testid={`${prefix}-err-${k}`}>{errors[k]}</p>}
        </div>
      ))}
    </div>
  );
}
